const DataTable = require('../util/data-table');

var Users = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = opts || {};
    this.init();
};

Users.prototype = {
    constructor: Users,
    $el: undefined,
    $table: undefined,
    options: undefined,
    userRoleFilter: undefined,
    dataTable: undefined,
    init: function() {
        var self = this;
        self.$table = $('.users-section-directory');
        if (self.$table.length) {
            window.userQueryParams = function(params) { return self.userQueryParams(params) };

            self.userRoleFilter = self.$table.find('table').attr('data-user-role');

            this.$el.find('.user-roles-select').removeClass('d-none');

            self.$table.on('click', 'table td a.view-btn', function(evt) {
                evt.preventDefault();
                self.handleViewAction($(evt.target).closest('tr').find('td:first-child').html(), evt);
                return false;
            });

            this.$el.find('.user-roles-select').on('change', function(e) {
                window.location = e.target.value;
            });

            self.$table.on('click', 'table td a.delete-btn', function(evt) {
                evt.preventDefault();
                self.handleDeleteButton($(evt.currentTarget));
                return false;
            });
    
            $('#standard-modal').on('click', 'a.delete-btn', function(evt) {
                evt.preventDefault();
                self.requestDeleteButton($(evt.currentTarget));
                return false;
            });

            self.dataTable = new DataTable(self.$table.find('table'), {
                height: true
            });
        }
    },
    userQueryParams: function(params) {
        params.role = this.userRoleFilter;
        return params;
    },
    handleViewAction: function(id, evt) {
        $.get(evt.currentTarget.href).done(function(response) {
            var $modal = $('#standard-modal');
            $modal.find('.modal-header h5').html('User Info');
            $modal.find('.modal-body').html(response);
            $modal.find('.modal-footer').html(
                '<a href="/admin/orders?search=' + id + '" class="btn btn-outline-primary btn-sm">Orders</a>'
            );
            var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
            instance.show();
        });
    },
    handleDeleteButton: function($link) {
        var self = this,
            href = $link.attr('href');
        $.get(href).done(function(response) {
            var $modal = $('#standard-modal');
            $modal.find('.modal-header h5').html('Delete User');
            $modal.find('.modal-body').html(response);
            $modal.find('.modal-footer').html(
                '<a href="' + href + '" class="btn btn-danger delete-btn">Delete</a>\
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>'
            );
            var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
            instance.show();
        });
    },
    requestDeleteButton: function($link) {
        var self = this,
            href = $link.attr('href');
        $.post(href + '?delete=true', {
            '_token': $link.closest('.modal-content').find('input[type=hidden]').val()
        }).done(function(response) {
            if (response.success) {
                self.dataTable.$el.bootstrapTable('refresh');
                var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
                instance.hide();
            }
        });
    }
};

module.exports = Users;